import dayjs from 'dayjs';
import { BsThreeDots } from 'react-icons/bs';
import { Card } from '../../../../../../components/card/card';
import { Chip } from '../../../../../../components/chip/chip';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import { Table } from '../../../../../../features/table/table';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { useStatementsStore } from '../../../../../../store/use-statements-store';
import { statementTypeTitleMap, statusTitleMap } from '../use-statements';
import s from './statements-table.module.css';

export const StatementsTable = () => {
  const { t, getLocale } = useLang();
  const { list, isLoading } = useStatementsStore();
  const updateStatementStatus = useModalParams('updateStatementStatus');

  return (
    <Card>
      <Table
        id="statement-list"
        frontPagination
        columnSettings
        className={s.table}
        isLoading={isLoading}
        cols={{
          employee: { label: t('Сотрудник') },
          tags: {
            label: t('Должности'),
          },
          status: {
            label: t('Статус'),
          },
          type: {
            label: t('Тип'),
          },
          period: {
            label: t('Период'),
          },
          actions: {
            label: t('Действие'),
          },
        }}
        rows={list?.map((item) => {
          const period = `${dayjs(item.start_date).format('DD.MM')} - ${dayjs(item.end_date).format(
            'DD.MM',
          )}`;

          return {
            employee: `${getLocale(item.staff?.name)} ${getLocale(item.staff?.surname)}`,
            tags: (
              <ul className={s.chips}>
                {item.staff?.tags?.map((tag) => (
                  <Chip variant="info" size="md" key={tag.id}>
                    {tag.value}
                  </Chip>
                ))}
              </ul>
            ),
            status: t(statusTitleMap[item.status]),
            type: t(statementTypeTitleMap[item.type]),
            period,
            actions: (
              <HasAccess service="staff" permissions={['write']}>
                <div className={s.actions}>
                  <IconButton
                    variant="secondary"
                    size="sm"
                    disabled={isLoading}
                    onClick={() =>
                      updateStatementStatus.handleOpenModal({ statement: JSON.stringify(item) })
                    }
                  >
                    <BsThreeDots />
                  </IconButton>
                </div>
              </HasAccess>
            ),
          };
        })}
      />
    </Card>
  );
};
